module.exports = __webpack_public_path__ + "static/media/iconPhone.f46d0262.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconPhone.svg
// module id = 997
// module chunks = 0